<template>
    <div
        v-on-clickaway="handleClickaway"
        class="dropdown"
        @keydown.tab="handleTabPress"
        :class="{ open : listOpen }"
    >
        <button
            type="button"
            :class="triggerStyle"
            :aria-expanded="listOpen ? 'true' : 'false'"
            :aria-controls="`dropdown-body_${uniqueId}`"
            :aria-labelledby="`${triggerLabel} dropdown-${uniqueId}-title`"
            @click="toggleList"
            @keydown.esc="closeList"
        >


            <!-- <span
                :id="`dropdown-${uniqueId}-title`"
                class="dropdown__toggle-label">{{ triggerTitle }}</span> -->

            <span :id="`dropdown-${uniqueId}-title`">
                <slot
                    v-if="hasTriggerTitleSlot"
                    name="triggerTitle"></slot>
                <span
                    v-else
                    class="dropdown__toggle-label">{{ triggerTitle }}</span>
            </span>

            <svg
                v-if="triggerIconVisible"
                width="11"
                height="11"
                viewBox="0 0 11 11"
                xmlns="http://www.w3.org/2000/svg"
                class="dropdown__toggle-icon"><path
                    d="M6.208 8.676a.934.934 0 0 1-1.416 0L1.225 4.533a.925.925 0 0 1-.14-.993.933.933 0 0 1 .848-.54h7.135c.364 0 .695.211.847.54a.925.925 0 0 1-.14.993L6.208 8.676z"/></svg>
        </button>

        <div
            :id="`dropdown-body_${uniqueId}`"
            class="dropdown__body"
            :class="[{hidden : !listOpen}, bodyDirection]"
            @keydown.esc.stop="closeList"
        >
            <div>
                <a
                    @click.prevent="closeList()"
                    href=""
                    class="dropdown__body-title"
                    :aria-label="trans('close_dropdown')"
                >
                    <div class="dropdown__body-title-icon">
                        <svg
                            :id="`icon-menu-go-back-${uniqueId}`"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.7571 3.31408C11.5564 3.113 11.2841 3 11 3C10.716 3 10.4436 3.113 10.243 3.31408L5.31409 8.24294C4.8953 8.66174 4.8953 9.33825 5.31409 9.75704L10.243 14.6859C10.6618 15.1047 11.3383 15.1047 11.7571 14.6859C12.1758 14.2671 12.1758 13.5906 11.7571 13.1718L7.59061 8.99462L11.7571 4.82817C12.1758 4.40938 12.1651 3.72213 11.7571 3.31408Z"/>
                        </svg>
                    </div>
                    {{ headerTitle }}
                </a>
            </div>
            <div class="dropdown__body-content"><slot > </slot></div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mixin as clickaway } from "vue-clickaway";
import { v4 as uuidv4 } from "uuid";

export default {
    mixins: [clickaway],
    props: {
        triggerLabel: {
            type: String,
            required: false,
            default: ""
        },
        triggerTitle: {
            type: String,
            required: true
        },
        triggerStyle: {
            type: String,
            default: "button dropdown__toggle"
        },
        triggerIconVisible: {
            type: Boolean,
            required: false,
            default: true
        },
        headerTitle: {
            type: String,
            required: true
        },
        bodyDirection: {
            type: String,
            required: false,
            default: "center"
        }
    },
    data() {
        return {
            listOpen: false,
            firstFocusableElement: null,
            lastFocusableElement: null,
            documentScrollTop: null,
            isMobile: false,
            uniqueId: uuidv4(),
        };
    },
    computed: {
        isAModalOpen() {
            return this.$store.getters["modalModule/isModalOpen"];
        },
        hasTriggerTitleSlot() {
            return !!this.$slots["triggerTitle"];
        }
    },
    mounted: function() {
        // Responsive Behavior
        /* istanbul ignore next */
        this.$responsive.registerMediaQuery("to-medium", () => {
            if(!document.documentElement.classList.contains("js-fullscreen") && this.listOpen){
                this.documentScrollTop = (
                    document.scrollingElement ||
                    document.documentElement ||
                    document.body.parentNode ||
                    document.body
                ).scrollTop;
                // Add a Modal-Open class on html tag (disable scroll in css)
                document.documentElement.classList.add("js-fullscreen");
            }
            this.isMobile = true;
        }, () => {
            if(document.documentElement.classList.contains("js-fullscreen") && this.listOpen){
                // Remove Modal-Open class on html tag
                document.documentElement.classList.remove("js-fullscreen");
            }
            this.isMobile = false;
        });
    },
    methods: {
        toggleList: function() {
            if (this.listOpen === true) {
                this.closeList();
            } else {
                this.openList();
            }
        },
        openList: function() {
            var focusableElements = Array.from(this.$el.querySelector(".dropdown__body").querySelectorAll(
                "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex=\"0\"]"
            ));

            this.firstFocusableElement = focusableElements[0];

            // Save last focusable element of the modal
            this.lastFocusableElement = focusableElements.pop();

            var windowWidth = this.$store.getters["responsiveModule/getCurrentWindowWidth"];

            if(windowWidth < (this.$responsive.breakpointsInPx().desktop)) {
                this.documentScrollTop = (
                    document.scrollingElement ||
                    document.documentElement ||
                    document.body.parentNode ||
                    document.body
                ).scrollTop;
                // Add a fullscreen class on html tag (disable scroll in css)
                if(!document.documentElement.classList.contains("js-fullscreen")){
                    document.documentElement.classList.add("js-fullscreen");
                }
            }
            this.listOpen = true;
            this.$emit("click");

            Vue.nextTick(() => {
                this.firstFocusableElement.focus();
            });
        },
        closeList: function() {
            this.closeListWithoutRefresh();
            this.$emit("closeList");
        },
        closeListWithoutRefresh() {
            if( this.listOpen === true && this.isAModalOpen === false) {

                var windowWidth = this.$store.getters["responsiveModule/getCurrentWindowWidth"];

                if(windowWidth < this.$responsive.breakpointsInPx().desktop && document.documentElement.classList.contains("js-fullscreen")){
                    window.scroll(0, this.documentScrollTop);

                    document.documentElement.classList.remove("js-fullscreen");
                }
                this.listOpen = false;
            }
        },
        handleTabPress: function(event) {
            if(document.documentElement.classList.contains("js-fullscreen")) {
                if (event.shiftKey === true) {
                    //Tab backward
                    if (document.activeElement === this.firstFocusableElement) {
                        event.preventDefault();
                        this.lastFocusableElement.focus();
                    }
                } else {
                    // Tab forward
                    if (document.activeElement === this.lastFocusableElement) {

                        event.preventDefault();
                        this.firstFocusableElement.focus();
                    }
                }
            }
        },
        handleClickaway: function() {
            if(this.isMobile === false && this.listOpen) {
                this.closeList();
            }
        },
    },
};
</script>